import AxiosClient from "../AxiosClient";

// 臨時スケジュール更新Api
export const postStaffStockSearchInfoListAPI = (params) => {
  return AxiosClient.post("/api/staffStock/searchInfoList", params);
  
}
export const downloadStaffStockPrintInfo = (requestBody = {}) => {
  const url = `/api/staffStock/printInfoList`;
  return AxiosClient.post(url, requestBody, {
    responseType: "arraybuffer",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(response => {
      return response;
    })
    .catch(error => {
      console.error("Error:", error);
    });
};

export const postUpdateAvailableStockAPI = (params) => {
  return AxiosClient.post("/api/staffStock/updateAvailableStock", params);
}

export const postPrintStockQrAPI = async (params) => {

  return AxiosClient.post(
    "/api/staffStock/printStockQr",
    params, 
    {
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "application/json",
      },
    }
  )    
  .catch(error => {
    console.error("Error:", error);
  });
}

